import type { ProjectFlowProps } from '../project-flows'
import { PROJECT_FLOW_COMPONENTS } from '../project-flows'
import { StepSession } from './StepSession'

export const VoiceConversationFlow = ({
  projectId,
  projectName,
  pointsAmount,
  onBack,
  onCompleted
}: ProjectFlowProps) => {
  return (
    <StepSession
      projectId={projectId}
      projectName={projectName}
      pointsAmount={pointsAmount}
      onBack={onBack}
      onCompleted={onCompleted}
    />
  )
}

PROJECT_FLOW_COMPONENTS.set('VOICE_CONVERSATION', VoiceConversationFlow)
